import { CheckCircle2, XCircle } from "lucide-react";

// Real email delivery state of this space: every gate that must be open for an email to really leave.
export default function EmailDeliveryState({ d, testid = "email-delivery-state" }) {
  if (!d) return null;
  return (
    <div className={`rounded-md border px-3 py-2 text-xs ${d.active ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-amber-200 bg-amber-50 text-amber-900"}`} data-testid={testid} role="status">
      <p>Invio email reale: <b data-testid={`${testid}-label`}>{d.active ? "attivo" : "spento"}</b>.{" "}
        {d.active ? (d.scope === "pilot" ? "Modalità pilota: partono solo verso i destinatari autorizzati." : "Le nuove email partono davvero.") : "Le email preparate restano in anteprima e non vengono spedite; le email già in coda non partiranno nemmeno dopo l'attivazione."}</p>
      {!d.active && <ul className="mt-1 space-y-0.5">{d.steps.map((s) => (
        <li key={s.id} className="flex items-center gap-1.5" data-testid={`${testid}-step-${s.id}`}>
          {s.ok ? <CheckCircle2 size={12} className="text-emerald-600" aria-hidden /> : <XCircle size={12} className="text-amber-700" aria-hidden />}
          <span>{s.label}{s.ok ? "" : " — da fare (a cura di MUSORA)"}</span></li>))}</ul>}
    </div>);
}
